import React, { useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';

function AddPodcast() {
    const [podcast, setPodcast] = useState({
        title: '',
        description: '',
        image_url: '',
        isDefault: false
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setPodcast({
            ...podcast,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/podcast`, podcast);
            if (response.data.success) {
                toast.success('پادکست با موفقیت اضافه شد!');
                setPodcast({
                    title: '',
                    description: '',
                    image_url: '',
                    isDefault: false
                });
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error("Error adding podcast:", error);
            toast.error('خطا در افزودن پادکست');
        }
    };

    return (
        <>
            <Navbar />
            <div className="container mt-5 mb-5">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <div className="card shadow">
                            <div className="card-header bg-primary text-white">
                                <h3 className="mb-0">🎙️ افزودن پادکست جدید</h3>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label">عنوان *</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            name="title" 
                                            value={podcast.title} 
                                            onChange={handleChange} 
                                            required 
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">توضیحات</label>
                                        <textarea 
                                            className="form-control" 
                                            name="description" 
                                            value={podcast.description} 
                                            onChange={handleChange} 
                                            rows="3"
                                            placeholder="توضیحات پادکست..."
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">آدرس تصویر</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            name="image_url" 
                                            value={podcast.image_url} 
                                            onChange={handleChange} 
                                            placeholder="https://example.com/podcast-cover.jpg" 
                                        />
                                    </div>

                                    <div className="mb-3 form-check">
                                        <input 
                                            type="checkbox" 
                                            className="form-check-input" 
                                            id="isDefault" 
                                            name="isDefault" 
                                            checked={podcast.isDefault} 
                                            onChange={handleChange} 
                                        />
                                        <label className="form-check-label" htmlFor="isDefault">
                                            پادکست پیش‌فرض (در صفحه اصلی نمایش داده می‌شود)
                                        </label>
                                    </div>

                                    <div className="d-flex justify-content-between">
                                        <button type="submit" className="btn btn-primary">➕ افزودن پادکست</button>
                                        <button type="button" className="btn btn-secondary" onClick={() => window.location.href = '/podcast'}>انصراف</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default AddPodcast;